import React from 'react';
import { Table, Skeleton } from 'antd';
import { ColumnsType } from 'antd/es/table';

interface TableSkeletonProps {
  rows?: number;
  columns?: ColumnsType<any>;
  showHeader?: boolean;
  showPagination?: boolean;
  animated?: boolean;
}

const TableSkeleton: React.FC<TableSkeletonProps> = ({
  rows = 10,
  columns = [],
  showHeader = true,
  showPagination = true,
  animated = true,
}) => {
  // Створюємо фіктивні дані для skeleton
  const skeletonData = Array.from({ length: rows }, (_, index) => ({
    key: `skeleton-${index}`,
    id: `skeleton-${index}`,
  }));

  // Створюємо skeleton колонки
  const skeletonColumns: ColumnsType<any> = columns.map((column, index) => ({
    ...column,
    render: () => (
      <Skeleton.Input
        active={animated}
        size="small"
        style={{
          width: index === 0 ? '60px' : index === columns.length - 1 ? '80px' : '120px',
          height: '20px',
        }}
      />
    ),
  }));

  // Якщо немає колонок, створюємо базові skeleton колонки
  if (skeletonColumns.length === 0) {
    skeletonColumns.push(
      {
        title: showHeader ? <Skeleton.Input active={animated} size="small" style={{ width: '80px' }} /> : '',
        dataIndex: 'col1',
        key: 'col1',
        width: '15%',
        render: () => <Skeleton.Input active={animated} size="small" style={{ width: '60px' }} />,
      },
      {
        title: showHeader ? <Skeleton.Input active={animated} size="small" style={{ width: '100px' }} /> : '',
        dataIndex: 'col2',
        key: 'col2',
        width: '20%',
        render: () => <Skeleton.Input active={animated} size="small" style={{ width: '120px' }} />,
      },
      {
        title: showHeader ? <Skeleton.Input active={animated} size="small" style={{ width: '60px' }} /> : '',
        dataIndex: 'col3',
        key: 'col3',
        width: '10%',
        render: () => <Skeleton.Input active={animated} size="small" style={{ width: '50px' }} />,
      },
      {
        title: showHeader ? <Skeleton.Input active={animated} size="small" style={{ width: '150px' }} /> : '',
        dataIndex: 'col4',
        key: 'col4',
        width: '35%',
        render: () => <Skeleton.Input active={animated} size="small" style={{ width: '200px' }} />,
      },
      {
        title: showHeader ? <Skeleton.Input active={animated} size="small" style={{ width: '80px' }} /> : '',
        dataIndex: 'col5',
        key: 'col5',
        width: '20%',
        render: () => <Skeleton.Input active={animated} size="small" style={{ width: '80px' }} />,
      },
    );
  }

  return (
    <Table
      dataSource={skeletonData}
      columns={skeletonColumns}
      pagination={showPagination ? {
        pageSize: rows,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: () => <Skeleton.Input active={animated} size="small" style={{ width: '150px' }} />,
        disabled: true,
      } : false}
      showHeader={showHeader}
      size="small"
      scroll={{ x: true }}
      style={{
        pointerEvents: 'none',
        opacity: 0.8,
      }}
    />
  );
};

export default TableSkeleton; 